import { formatPrice } from 'shared/lib/formatting';

interface TotalTooltipContentProps {
  budget: string;
  refund: string;
}

export function TotalTooltipContent({ budget, refund }: TotalTooltipContentProps) {
  return (
    <div>
      <div>Budget {formatPrice(Number(budget))}</div>
      <div>Refunds {formatPrice(Number(refund))}</div>
    </div>
  );
}
